<template>
  <div class="inner-window">
    <div class="py-4 flex-1 flex flex-col">
      <div>InnerWindow</div>
      <div>query: {{ query }}</div>
      <div>User: {{ user }}</div>
      <div>Props: {{ $props }}</div>
    </div>
    <div class="flex flex-row justify-end">
      <el-button type="primary" @click="confirm">Confirm</el-button>
      <el-button type="default" @click="cancel">Cancel</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  emits: ["confirm", "cancel"],
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    query() {
      return this.$route.query;
    },
    ...mapState({
      user: (state) => state.user,
    }),
  },
  methods: {
    confirm() {
      this.$emit("confirm", "ok");
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped>
.inner-window {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
